import React from 'react';
import { Link } from 'react-router-dom';
import { useForm, ValidationError } from '@formspree/react';
import './Contact.css';

function Contact() {
  const [state, handleSubmit] = useForm('mqewrgkd');

  return (
    <main className="contact-page">

      {/* HEADER */}
      <section className="ct-header">
        <div className="ct-container">
          <div className="ct-header-row">
            <div>
              <p className="ct-eyebrow">Get in touch</p>
              <h1>Tell us about your <em>project.</em></h1>
              <p className="ct-lede">
                Ready to start, request a quote, or talk through ideas?
                Send a quick message and we&apos;ll follow up with next steps.
              </p>
            </div>
            <div className="ct-header-meta">
              <div className="ct-header-meta-row">
                <span>Reply</span>
                <span>Within 48 hours</span>
              </div>
              <div className="ct-header-meta-row">
                <span>First step</span>
                <span>A short intro call</span>
              </div>
              <div className="ct-header-meta-row">
                <span>Pricing</span>
                <span>From $1,499</span>
              </div>
              <div className="ct-header-meta-row">
                <span>Includes</span>
                <span>Domain &amp; hosting setup</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FORM + SIDE INFO */}
      <section className="ct-main">
        <div className="ct-container">
          <div className="ct-layout">

            {/* FORM */}
            {state.succeeded ? (
              <div className="ct-success">
                <p className="ct-success-heading">Inquiry sent.</p>
                <p className="ct-success-body">
                  Thanks for reaching out, we&apos;ll be in touch within 48 hours.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="ct-form">
                <div className="ct-form-head">
                  <div className="ct-form-head-dots"><span /><span /><span /></div>
                  <span className="ct-form-head-title">New inquiry · draft</span>
                  <span className="ct-form-head-status">Encrypted &amp; private</span>
                </div>

                <div className="ct-form-body">
                  <p className="ct-form-label">Inquiry form</p>

                  <div className="ct-field-grid">
                    <label className="ct-field">
                      <span className="ct-field-label">Name</span>
                      <input
                        type="text"
                        name="name"
                        required
                        placeholder="Your name"
                        className="ct-input"
                      />
                      <ValidationError field="name" errors={state.errors} className="ct-field-error" />
                    </label>

                    <label className="ct-field">
                      <span className="ct-field-label">Email</span>
                      <input
                        type="email"
                        name="email"
                        required
                        placeholder="you@example.com"
                        className="ct-input"
                      />
                      <ValidationError field="email" errors={state.errors} className="ct-field-error" />
                    </label>
                  </div>

                  <div className="ct-field-grid">
                    <label className="ct-field">
                      <span className="ct-field-label">
                        Phone <span className="ct-field-optional">(optional)</span>
                      </span>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="+1 (555) 000-0000"
                        className="ct-input"
                      />
                      <ValidationError field="phone" errors={state.errors} className="ct-field-error" />
                    </label>

                    <label className="ct-field">
                      <span className="ct-field-label">Project type</span>
                      <select
                        name="project_type"
                        defaultValue=""
                        required
                        className="ct-input"
                      >
                        <option value="" disabled>Select an option</option>
                        <option value="starter">Starter ($1,499)</option>
                        <option value="business">Business ($2,499)</option>
                        <option value="practice">Practice ($3,999)</option>
                        <option value="ecommerce">Commerce ($4,499)</option>
                        <option value="maintenance">Ongoing maintenance &amp; updates</option>
                        <option value="other">Other / not sure yet</option>
                      </select>
                      <ValidationError field="project_type" errors={state.errors} className="ct-field-error" />
                    </label>
                  </div>

                  <label className="ct-field">
                    <span className="ct-field-label">Message</span>
                    <textarea
                      name="message"
                      rows="5"
                      placeholder="Tell us about your business, your current site (if you have one), and what you'd like a new site to do for you."
                      className="ct-input ct-textarea"
                    />
                    <ValidationError field="message" errors={state.errors} className="ct-field-error" />
                  </label>
                </div>

                {state.errors && state.errors.length > 0 && (
                  <p className="ct-status ct-status-error">
                    Something went wrong. Please check the fields above and try again.
                  </p>
                )}

                <div className="ct-form-foot">
                  <p className="ct-form-foot-note">
                    We read every message. No drip campaigns, no follow-up spam.
                  </p>
                  <button
                    type="submit"
                    className="ct-btn ct-btn-primary ct-btn-arrow"
                    disabled={state.submitting}
                  >
                    {state.submitting ? 'Sending...' : 'Send inquiry'}
                  </button>
                </div>
              </form>
            )}

            {/* SIDE INFO */}
            <aside className="ct-side">
              <div className="ct-side-block">
                <p className="ct-side-eyebrow">Typical projects</p>
                <h3>What we usually build.</h3>
                <ul className="ct-side-list">
                  <li>New business website</li>
                  <li>Website refresh or restructuring</li>
                  <li>Booking-ready service site</li>
                  <li>Online shop or product catalog</li>
                  <li>Simple landing page or promo page</li>
                </ul>
              </div>

              <div className="ct-side-block">
                <p className="ct-side-eyebrow">Response time</p>
                <h3>What happens next.</h3>
                <p className="ct-side-text">
                  We&apos;ll follow up within 48 hours by email. First step is usually
                  a quick call to hear about your project and answer any questions
                  before anything is committed.
                </p>
              </div>

              <div className="ct-side-block ct-side-block-quiet">
                <p className="ct-side-eyebrow">Not sure what you need?</p>
                <h3>Take the matchmaker.</h3>
                <p className="ct-side-text">
                  Take the 10-question package quiz. It&apos;ll point you to the tier
                  that fits your project.
                </p>
                <Link to="/#quiz" className="ct-side-link">
                  Take the quiz
                </Link>
              </div>
            </aside>

          </div>
        </div>
      </section>

    </main>
  );
}

export default Contact;